import { render, staticRenderFns } from "./ProductOffer.vue?vue&type=template&id=a663a866"
import script from "./ProductOffer.vue?vue&type=script&lang=js"
export * from "./ProductOffer.vue?vue&type=script&lang=js"
import style0 from "./ProductOffer.vue?vue&type=style&index=0&id=a663a866&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports